// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"tv"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M6 18L2.00099 18L2 3H22L22 18H18","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M8.46585 20.5375L7.75874 21.2446H7.75732L8.46585 20.5375ZM8.46585 20.5375L12 17.002L15.5355 20.5375M15.5355 20.5375L16.2426 21.2446H16.244L15.5355 20.5375Z","strokeLinecap":"round","strokeWidth":"props.strokeWidth"}}]}]};

const TvIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tv',
    ref,
    icon: element,
  },
));

TvIcon.displayName = 'TvIcon';

export default TvIcon;
